module.exports = __webpack_public_path__ + "img/right.a109ac87.svg";